const getMediaUrl = (path) => {
    if (!path) return '';
    if (/^(https?:)?\/\//.test(path) || path.startsWith('data:') || path.startsWith('blob:')) {
        return path;
    }

    const API_BASE_URL = import.meta.env.VITE_APP_API_BASE_URL;
    const baseUrl = API_BASE_URL ? API_BASE_URL.replace(/\/$/, '') : '';

    return path.startsWith("/media") || path.startsWith("/public") ? `${baseUrl}${path}` : `${path}`;
};


export const getDefaultProductImage = (product) => {
    const images = product?.images ?? [];
    return images.find((image) => image?.is_default)?.image ?? images[0]?.image ?? '';
};

/** Returns the thumbnail URL for a card/small display, falling back to full image. */
export const getDefaultProductThumbnail = (product) => {
    const images = product?.images ?? [];
    const img = images.find((image) => image?.is_default) ?? images[0];
    return img?.thumbnail || img?.image || '';
};


export  const capitalize = (str) => {
    if (typeof str !== 'string') return '';
    return str.charAt(0).toUpperCase() + str.slice(1);
};

export default getMediaUrl;
